import { apiClient } from './api';

export const authApi = {
  changeUserRole: async (userId: number, role: string): Promise<any> => {
    return apiClient.put(`/auth/user/${userId}/role`, { role });
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<{ message: string }> => {
    return apiClient.post<{ message: string }>('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  },

  resetPassword: async (employeeId: number): Promise<{ message: string; employee: { id: number; name: string; empNo: string } }> => {
    return apiClient.post<{ message: string; employee: { id: number; name: string; empNo: string } }>(`/auth/reset-password/${employeeId}`, {});
  },
};
